import React, { useState } from "react"
import { Link } from "gatsby"
// import logo from "../../images/logo.png"
import WebriQForm from "../form/form"
import { Form } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"

const Footer = () => {
  const [tel, setTel] = useState("")
  const [errMessage, setErrMessage] = useState("")

  const normalizeInput = (value, previousValue) => {
    if (!value) return value
    const currentValue = value.replace(/[^\d]/g, "")
    const cvLength = currentValue.length

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`
    }
  }

  const onChange = e => {
    setTel(normalizeInput(e.target.value, tel))
    setErrMessage("")
  }

  const onFocusOut = e => {
    // console.log("it works")
    if (e.target.value.length < 14) {
      setTel("")
      setErrMessage("Please provide exact, (NXX) NXX-XXXX")
    }
  }

  return (
    <div id="footer">
      <section id="contact">
        <div className="container">
          <div className="contact-content">
            <div className="row justify-content-between">
              <div className="col-md-5">
                <h2 className="section-title text-pink mb-5">
                  Come see the Difference at Assured Assisted Living!
                </h2>
                <p className="section-p">
                  If you have any questions please give us a call at&nbsp;
                  <a title="contact" href="tel:(303)814-2688">
                    (303)814-2688
                  </a>{" "}
                  or you may also fill out the form below to send us a message
                  and we will follow up with you as soon as possible.
                </p>
                <p className="section-p mb-5">
                  Thank you again for visiting our website. Please fill in the
                  form below to contact us or to schedule a tour.
                </p>
              </div>
              <div className="col-md-6 text-center">
                <WebriQForm
                  form_name="Contact Us Form"
                  form_id="5ea005db6d4bd86beef0baaf"
                  form_classname="contact-us"
                  method="POST"
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          name="name"
                          placeholder="Name"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="email"
                          name="email"
                          placeholder="Email"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <input
                          onBlur={onFocusOut}
                          onChange={onChange}
                          className="form-control"
                          type="text"
                          name="phone"
                          placeholder="Phone Number"
                          value={tel}
                          required
                        />
                        {errMessage && (
                          <p className="text-danger text-left">
                            <small> {errMessage}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group text-left">
                        <Form.Group
                          controlId="desiredlocation"
                          className="form-group input-select"
                        >
                          <Form.Control as="select" name="Desired Location?">
                            <option defaultValue="Choose...">Choose...</option>
                            <option value="Castle Rock">Castle Rock</option>
                            <option value="Centennial">Centennial</option>
                            <option value="Lakewood">Lakewood </option>
                            <option value="Littleton">Littleton </option>
                            <option value="Parker">Parker</option>
                          </Form.Control>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          className="form-control mb-2"
                          name="message"
                          placeholder="Message"
                          rows={3}
                          defaultValue={""}
                        />
                      </div>
                    </div>
                    <div className="col-12 mb-4">
                      <div className="form-group">
                        <div className="webriq-recaptcha" />
                      </div>
                    </div>
                    <div className="form-group w-100 px-3 mt-2 text-left">
                      <button className="hero-cta" type="submit">
                        Submit Now
                      </button>
                    </div>
                  </div>
                </WebriQForm>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="top-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="footer-left-content text-violet">
                <h4 className="section-title">Connect With Us</h4>
                <div className="footer-location d-flex align-content-center justify-content-sm-start">
                  <i className="fa fa-map-marker mr-2" />
                  <p className="section-p">
                    599 Topeka Way Suite #303 Castle Rock, CO 80109, USA
                  </p>
                </div>
                <div className="footer-phone d-flex align-content-center justify-content-sm-start mb-3">
                  <i className="fa fa-phone mr-2" />
                  <a title="contact" href="tel:(303)814-2688">
                    (303)814-2688
                  </a>
                </div>
                <div className="footer-mail d-flex align-content-center justify-content-sm-start mb-4">
                  <i className="fa fa-envelope mr-2" />
                  <a title="email" href="mailto:francis@assuredal.com">
                    francis@assuredal.com
                  </a>
                </div>
                <div className="footer-social d-flex align-content-center justify-content-sm-start">
                  <a
                    title="facebook"
                    className="facebook mr-2"
                    href="https://www.facebook.com/assuredassistedliving1/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-facebook" />
                  </a>
                  <a
                    title="twitter"
                    className="twitter mr-2"
                    href="https://twitter.com/AssuredAL"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-twitter" />
                  </a>
                  <a
                    title="linkedin"
                    className="linkedin mr-2"
                    href="https://www.linkedin.com/company/assured-assisted-living/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-linkedin" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer-center-content text-violet">
                <h4 className="section-title">Our Services</h4>
                <ul className="px-0">
                  <li>
                    <Link title="who we are" to="/alzhiemers-care">
                      Who We Are
                    </Link>
                  </li>
                  <li>
                    <Link
                      title="what we do"
                      to="/alzheimers-home-memory-care-castle-rock"
                    >
                      What We Do
                    </Link>
                  </li>
                  <li>
                    <Link
                      title="alzhaeimers daily activities"
                      to="/alzheimers-activities"
                    >
                      Alzheimer's Daily Activities
                    </Link>
                  </li>
                  <li>
                    <Link
                      title="Alzheimers answered"
                      to="/alzheimers-questions-answered"
                    >
                      Alzheimers Questions Answered
                    </Link>
                  </li>
                  <li>
                    <Link title="Testimonial" to="/testimonial">
                      Testimonials
                    </Link>
                  </li>
                  <li>
                    <Link title="blog/article" to="/blog">
                      Alzheimers Care Blog
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footer-right-content mt-3">
                <a title="logo" className="footer-logo" href="/">
                  <StaticImage
                    placeholder="blurred"
                    className="img-fluid mb-4"
                    src="../../images/logo.png"
                    alt="Logo"
                  />
                </a>
                <p className="section-p">
                  Copyright © 2010-2021 Assured Assisted Living Castle Rock.
                </p>
                <p className="section-p">
                  Design &amp; Developed by&nbsp;
                  <a
                    title="webriq"
                    className="a-webriq"
                    href="https://webriq.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    WebriQ.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Footer
